import React, { useEffect, useState } from 'react';
import DashboardLayout from 'layout/dashboardLayout';
import StepOne from './CreateProductSteps/StepOne';
import StepTwo from './CreateProductSteps/StepTwo';
import StepConfigureForm from './CreateProductSteps/StepConfigureForm';
import StepFour from './CreateProductSteps/StepFour';
import { fetchBusinessSectors } from 'store/actions/new-product';
import { createCollection } from 'store/actions/products';
import { connect, useSelector } from 'react-redux';
import StepThree from './CreateProductSteps/StepThree/StepThree';
import { useHistory } from 'react-router';
import { v4 as uuid } from 'uuid';
import FirebaseAnalytics, { AnalyticsLogStatus } from 'libs/analytics';
import { SUPPORT_OFFICER } from 'libs';

const CreateProduct = ({ fetchBusinessSectors, createCollection }) => {
  const history = useHistory();
  const [step, setStep] = useState(1);
  const sectors = useSelector((state) => state.newProduct.businessSectors);
  const roleChecker = useSelector((state) => state.common.user);

  const [data, setData] = useState({
    // Step One
    merchantId: roleChecker.merchantId,
    title: '',
    description: '',
    businessSectorId: '',
    features: '',
    productImageUrl: '',
    productType: 'COLLECTION',

    // Step Two
    onboardingFields: [
      // Must  always be present - Phone Number
      {
        id: uuid(),
        value: 'Phone Number',
        property: 'number',
        hint: "Customer's phone number",
        name: 'Phone Number',
        max: '',
        required: true, //Must always be true
        type: 'CUSTOMER_PHONE_NUMBER',
        lookupRequired: false,
      },
    ],

    // StepThree
    amount: null,
    amountType: '',
    numOfPaymentOccurrence: 1,

    // Step Four
    collectionFields: [
      // Must  always be present - Phone Number
      {
        id: uuid(),
        value: 'Phone Number',
        property: 'number',
        hint: "Customer's phone number",
        name: 'Phone Number',
        max: '',
        required: true, //Must always be true
        type: 'CUSTOMER_PHONE_NUMBER',
        lookupRequired: false,
      },
    ],

    // Step Five
    lookupUrl: '',
    registrationCallbackUrl: '',
    paymentCallbackUrl: '',
    verify: false, // please never send this field as null
    verificationUrl: '',
  });

  const [amtType, setAmtType] = useState('');
  const [startTime, setStartTime] = useState(Date.now());

  const [money, setMoney] = useState({
    name: 'Amount',
    hint: 'This is the collection amount',
    type: 'MONEY',
    required: true,
    rank: 0,
    lookupRequired: false,
    ...(data.amountType === 'DYNAMIC' && {
      min: '',
      max: '',
    }),
    ...(data.amountType === 'PLAN' && {
      subFields: [],
    }),
  });

  useEffect(() => {
    setMoney({
      ...money,
      ...(data.amountType === 'PLAN' && {
        subFields: [],
      }),
    });
    sessionStorage.removeItem('amtType');
  }, [data.amountType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((data) => ({ ...data, [name]: value }));
  };

  useEffect(() => {
    fetchBusinessSectors();
  }, []);

  const handleChangeStep = (step) => {
    setStep(step);
  };
  const goBack = () => {
    if (step === 1) {
      history.push('/products/choose-template');
    } else {
      setStep(step - 1);
    }
  };

  useEffect(() => {
    if (roleChecker?.merchantUser?.role === SUPPORT_OFFICER) {
      history.push('/dashboard');
    }
  }, [roleChecker]);

  useEffect(() => {
    return () => {
      const endTime = Date.now();
      FirebaseAnalytics.logWithValue('product_creation_completion_time', {
        STATUS: AnalyticsLogStatus.SUCCESS,
        TIME: `${Math.round((endTime - startTime) / 1000)}s`,
      });
    };
  }, []);

  return (
    <DashboardLayout showBackIcon onGoBack={goBack}>
      <div>
        {step === 1 ? (
          <StepOne
            step={step}
            changeStep={handleChangeStep}
            sectors={sectors}
            handleChange={handleChange}
            data={data}
            setData={setData}
          />
        ) : step === 2 ? (
          <StepTwo
            step={step}
            changeStep={handleChangeStep}
            data={data}
            handleChange={handleChange}
            setData={setData}
          />
        ) : step === 3 ? (
          <StepThree
            step={step}
            changeStep={handleChangeStep}
            data={data}
            data={data}
            handleChanges={handleChange}
            setData={setData}
            money={money}
            setMoney={setMoney}
            amtType={amtType}
            setAmtType={setAmtType}
          />
        ) : step === 4 ? (
          <StepFour
            step={step}
            changeStep={handleChangeStep}
            data={data}
            handleChange={handleChange}
            setData={setData}
          />
        ) : step === 5 ? (
          <StepConfigureForm
            step={step}
            changeStep={handleChangeStep}
            data={data}
            handleChange={handleChange}
            setData={setData}
            createCollection={createCollection}
            money={money}
          />
        ) : null}
      </div>
    </DashboardLayout>
  );
};

export default connect(null, { fetchBusinessSectors, createCollection })(
  CreateProduct,
);
